import React from "react";
import styled from "@emotion/styled";

import Paper from "@mui/material/Paper";

const Container = styled(Paper)`
  cursor: pointer;
  font-weight: normal;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 14px;
  padding-left: 14px;
  font-size: 12px;
`;

type Props = {
  label: string;
  onClick: React.MouseEventHandler<HTMLDivElement>;
};

function MapInfo({ label, onClick }: Props): JSX.Element {
  return <Container onClick={onClick}>{label}</Container>;
}

export default MapInfo;
